import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Layout from '../layout/Layout'
import ClientForm from '../molecules/ClientForm'
import ChevronRightSvg from '../other/svg/ChevronRightSvg'
import { CREATE_CLIENT } from 'src/redux/clientReducer'
import { ClientFormData } from 'src/helpers/clientFormValidation'

const ClientCreate = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleCancel = (): void => {
    navigate('/selling/clients')
  }

  const onSubmit = (values: ClientFormData): void => {
    dispatch(CREATE_CLIENT(values))
    navigate('/selling/clients')
  }

  const initialValues: ClientFormData = {
    email: '',
    first_name: '',
    last_name: '',
    country: '',
    place: '',
    street: '',
    house_number: '',
    zip_code: '',
    phone_number: '',
    email_address: '',
    company_name: '',
    client_type: 'company',
    tax_number: '',
    vat_number: '',
    id_number: '',
    document_number: ''
  }

  return (
    <Layout withoutToolbar>
      <div className="flex flex-col justify-start items-start gap-4 h-[calc(100vh-100px)]">
        <div className="self-stretch min-h-14 bg-Estigroup-primary rounded-lg border border-neutral-200 flex flex-col justify-start items-center">
          <div className="self-stretch px-4 py-3 inline-flex justify-start items-center gap-3">
            <button
              type="button"
              onClick={handleCancel}
              className="text-foregrounds-fg-on-color text-xl font-semibold font-Montserrat leading-5">
              {t('clients.title')}
            </button>
            <ChevronRightSvg className="size-3.5 text-foregrounds-fg-on-color" />
            <div className="text-foregrounds-fg-on-color text-xl font-semibold font-Montserrat leading-5">
              {t('clients.add_client')}
            </div>
          </div>
        </div>
        <ClientForm initialValues={initialValues} onSubmit={onSubmit} onCancel={handleCancel} mode="create" />
      </div>
    </Layout>
  )
}

export default ClientCreate
